import ReactDOM from 'react-dom';
import App from './components/App';

const app = document.getElementById('app');
ReactDOM.render(<App />, app);
